export default __webpack_public_path__ + "static/media/sb3.ba82d221.png";